import { Injectable } from '@angular/core';
import { ComponentBase } from '../component-base';
import { ZoomService } from './zoom.service';
import {
  CANVAS_USES_POINTER_EVENTS,
  PINCH_DISTANCE_EPSILON,
  twoTouchesSeparation
} from '../utils/pointer-input.utils';

/** Pinch: Touch-события при `!CANVAS_USES_POINTER_EVENTS`; иначе ветка mouseDown/move через pointerType touch. */
@Injectable()
export class ZoomCameraService extends ComponentBase {
  private pinchDistance: number | null = null;
  private pointers = new Map<number, { x: number; y: number }>();

  constructor(private zoomSrvc: ZoomService) {
    super();
  }

  mouseScroll(e) {
    e.preventDefault();
    const delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY || -e.detail));
    if (delta > 0) {
      this.zoomSrvc.in(e);
    } else {
      this.zoomSrvc.out(e);
    }
  }

  fitRoom() {}

  private tryPinchZoom() {
    if (this.pointers.size !== 2) {
      this.pinchDistance = null;
      return;
    }
    const pts = Array.from(this.pointers.values());
    const nextDistance = Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y);
    if (!this.pinchDistance || this.pinchDistance <= 0) {
      this.pinchDistance = nextDistance;
      return;
    }
    const ratio = nextDistance / this.pinchDistance;
    if (Math.abs(ratio - 1) < PINCH_DISTANCE_EPSILON) {
      this.pinchDistance = nextDistance;
      return;
    }
    const current = this.zoomSrvc.getCurrentZoom();
    if (typeof current === 'number' && isFinite(current) && current > 0) {
      this.zoomSrvc.set(current / ratio);
    }
    this.pinchDistance = nextDistance;
  }

  mouseDown(e: any) {
    if (!e || e.pointerType !== 'touch' || typeof e.pointerId !== 'number') {
      return;
    }
    this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    this.tryPinchZoom();
  }

  mouseMove(e: any) {
    if (!e || e.pointerType !== 'touch' || typeof e.pointerId !== 'number') {
      return;
    }
    if (!this.pointers.has(e.pointerId)) {
      return;
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    this.tryPinchZoom();
  }

  mouseUp(e?: any) {
    if (!e || typeof e.pointerId !== 'number') {
      this.pointers.clear();
      this.pinchDistance = null;
      return;
    }
    this.pointers.delete(e.pointerId);
    if (this.pointers.size < 2) {
      this.pinchDistance = null;
    }
  }

  touchStart(e: TouchEvent) {
    if (CANVAS_USES_POINTER_EVENTS) {
      return;
    }
    if (!e || !e.targetTouches || e.targetTouches.length !== 2) {
      this.pinchDistance = null;
      return;
    }
    const d = twoTouchesSeparation(e.targetTouches);
    this.pinchDistance = d != null ? d : null;
  }

  touchMove(e: TouchEvent) {
    if (CANVAS_USES_POINTER_EVENTS) {
      return;
    }
    if (!e || !e.targetTouches || e.targetTouches.length !== 2) {
      return;
    }
    e.preventDefault();
    const nextDistance = twoTouchesSeparation(e.targetTouches);
    if (nextDistance == null) {
      return;
    }
    if (!this.pinchDistance || this.pinchDistance <= 0) {
      this.pinchDistance = nextDistance;
      return;
    }
    const ratio = nextDistance / this.pinchDistance;
    if (Math.abs(ratio - 1) < PINCH_DISTANCE_EPSILON) {
      this.pinchDistance = nextDistance;
      return;
    }
    const current = this.zoomSrvc.getCurrentZoom();
    if (typeof current === 'number' && isFinite(current) && current > 0) {
      this.zoomSrvc.set(current / ratio);
    }
    this.pinchDistance = nextDistance;
  }

  touchEnd() {
    if (CANVAS_USES_POINTER_EVENTS) {
      return;
    }
    this.pinchDistance = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/zoom-camera.service.ts